import { Component } from '@angular/core';

@Component({
  selector: 'app-robot-process-automation',
  templateUrl: './robot-process-automation.component.html',
  styleUrls: ['./robot-process-automation.component.scss']
})
export class RobotProcessAutomationComponent {
  advanceMoullding:any[] = [
    {
      title: 'Articulated Robots​​',
      img: 'assets/images/capability/white/robot_1.JPG',
    },
    {
      title: 'Cobots​',
      img: 'assets/images/capability/white/robot_2.JPG',
    },
    {
      title: 'Scara Robots',
      img: 'assets/images/capability/white/robot_3.JPG',
    },
    {
      title: 'Delta Robots​',
      img: 'assets/images/capability/white/robot_4.JPG',
    },
    {
      title: 'Cartesian Robots',
      img: 'assets/images/capability/white/robot_5.JPG',
    },
    // {
    //   title: 'Plastic To Rubber Bonding​',
    //   img: 'assets/images/placeholder.jpg',
    // }
  ]
  // produtData:any[] = [
  //   {
  //     title: 'Rubber Extrusion',
  //     img: 'assets/images/placeholder.jpg',
  //   },
  //   {
  //     title: 'Elastomer Moulding​​',
  //     img: 'assets/images/placeholder.jpg',
  //   },
  //   {
  //     title: 'Cryogenic Deflashing​',
  //     img: 'assets/images/placeholder.jpg',
  //   },
  //   {
  //     title: 'Metal to Rubber Parts​​​',
  //     img: 'assets/images/placeholder.jpg',
  //   },
  //   {
  //     title: 'Plastic to Rubber Bonding',
  //     img: 'assets/images/placeholder.jpg',
  //   },
  //   {
  //     title: 'Elastomer Calendering​​',
  //     img: 'assets/images/placeholder.jpg',
  //   }
  // ]  
  materialExpertise:any[] = [
    { 'item': 'Pick and Place'},
    { 'item': 'Machine Tending'},
    { 'item': 'Assembly'},
    { 'item': 'Packaging'},
    { 'item': 'Palletizing'},
    { 'item': 'Inspection'},
    { 'item': 'Material Removal'},
    { 'item': 'Dispensing'},
    //{ 'item': 'Silicone Rubber (Si)'},
    //{ 'item': 'Chloroprene Rubber (Cr)'}
  ]
  advancemoduldingtechniques:any[] = [
    { 'item': 'Installation & Support'},
    { 'item': 'System Integration'},
    { 'item': 'System Build'},
    { 'item': 'Concept'},
    { 'item': 'Feasibility Studies'},
    { 'item': 'System Design'}
  ]
  // manufacturingCapabilities:any[] = [
  //    { 'item':'Fully automated Rubber Mixing plant'},
  //    { 'item':'Automatic Bonding Plant.'},
  //    { 'item':'Injection, Transfer & Compression moulding presses'},
  //    { 'item':'Plastic Injection Moulding Machines'},
  //    { 'item':'Extrusion Plant'},
  //    { 'item':'Autoclave for hoses'}
  // ]
}
